import { render } from "./OrderItemsTable.vue?vue&type=template&id=28210787"
import script from "./OrderItemsTable.vue?vue&type=script&lang=js"
export * from "./OrderItemsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__